import React, { useState } from 'react';
import { Auth } from 'aws-amplify';
import HGForm from 'components/HGForm';
import { Button } from 'components/shadcn/ui/button';
import NewPasswordRequired from './NewPasswordRequired';

const SignIn = ({ triggerForgotPassword }) => {
    const [errorMessage, setErrorMessage] = useState(null);
    const [hasTemporaryPassword, sethasTemporaryPassword] = useState(null);
    const logIn = async (creds) => {
        setErrorMessage(null);
        try {
            const user = await Auth.signIn(creds.email, creds.password);
            if (user) {
                if (user.challengeName === 'NEW_PASSWORD_REQUIRED') {
                    sethasTemporaryPassword(user);
                } else {
                    window.location.href = '/';
                }
            }
        } catch (error) {
            setErrorMessage(error.message);
            console.log(error);
        }
    };

    if (hasTemporaryPassword)
        return <NewPasswordRequired user={hasTemporaryPassword} />;

    return (
        <div>
            <HGForm
                fields={{
                    email: 'Email',
                    password: 'Password',
                }}
                handleSubmit={logIn}
                buttonText="Login"
                errorMessage={errorMessage}
            />
            <Button
                className="mx-auto mt-3 block w-max text-sm font-light text-foreground"
                onClick={triggerForgotPassword}
                variant="link"
                color="dark"
            >
                <span>Forgot your password?</span>
            </Button>
        </div>
    );
};

export default SignIn;
